import React from "react";
import { PROFILE_CATEGORIES, parseLabel } from "./constants";
import { getChangedSettingsForComponent } from "./utils";
import SettingInput from "./SettingInput";

const ProfileSettings = ({
  tempSettings,
  deviceSettings,
  updateDeviceSettingIsLoading,
  hasChanges,
  handleSettingChange,
  handleCancelChanges,
  handleSaveChanges,
  isDrawer = false,
  readOnly = false,
}) => {
  if (!tempSettings) return null;

  const changedSettings = getChangedSettingsForComponent(
    deviceSettings,
    tempSettings
  );

  const hasAnySettingToShow = Object.values(PROFILE_CATEGORIES).some(
    (category) => category.settings.some((key) => tempSettings[key])
  );
  if (readOnly && !hasAnySettingToShow) {
    return (
      <div className="overflow-y-auto px-3 sm:px-1 mt-2 flex items-center justify-center min-h-[120px] text-gray-500 text-sm">
        Veritabanında bu cihaz için kayıtlı son ayar bulunamadı. Cihaz bir kez bağlandığında ayarlar burada gösterilecektir.
      </div>
    );
  }

  const categoryThemes = [
    {
      border: "border-purple-100",
      header: "from-white to-purple-50",
      icon: "bg-purple-100 text-purple-600",
      shadow: "shadow-purple-100",
      divider: "border-purple-50",
    },
    {
      border: "border-sky-100",
      header: "from-white to-sky-50",
      icon: "bg-sky-100 text-sky-600",
      shadow: "shadow-sky-100",
      divider: "border-sky-50",
    },
    {
      border: "border-rose-100",
      header: "from-white to-rose-50",
      icon: "bg-rose-100 text-rose-600",
      shadow: "shadow-rose-100",
      divider: "border-rose-50",
    },
  ];

  return (
    <>
      <div className="overflow-y-auto px-3 sm:px-1 mt-2">
        <div
          className={`grid grid-cols-1 gap-4 pb-6 ${updateDeviceSettingIsLoading || readOnly ? "opacity-50 pointer-events-none" : ""
            } md:grid-cols-2`}
        >
          {Object.entries(PROFILE_CATEGORIES).map(
            ([categoryKey, category], index) => {
              const relevantSettings = category.settings
                .map((settingKey) => ({
                  ...tempSettings[settingKey],
                  key: settingKey,
                }))
                .filter(Boolean);

              if (relevantSettings.length === 0) return null;

              const theme = categoryThemes[index % categoryThemes.length];

              return (
                <div
                  key={categoryKey}
                  className="overflow-hidden rounded-xl border border-gray-200 bg-white"
                >
                  <div className="flex items-center gap-2 px-3 py-2 border-b border-gray-100 bg-gray-50/60">
                    <div className={`flex h-5 w-5 items-center justify-center rounded-md ${theme.icon}`}>
                      <category.icon className="h-3 w-3" />
                    </div>
                    <span className="text-xs font-semibold text-gray-600">
                      {category.title}
                    </span>
                  </div>
                  <div className="p-3 pt-4 sm:p-4 sm:pt-5 min-w-0">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 sm:gap-3">
                      {relevantSettings.map((setting) => (
                        <SettingInput
                          key={setting.key}
                          setting={{
                            ...setting,
                            label: parseLabel(setting.label),
                          }}
                          onChange={(value) =>
                            handleSettingChange(setting.key, value)
                          }
                          isChanged={!!changedSettings[setting.key]}
                          originalValue={changedSettings[setting.key]?.original}
                          disabled={readOnly}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              );
            }
          )}
        </div>
      </div>
    </>
  );
};

export default ProfileSettings;
